import { apiGet, apiPatch } from './client';
import type {
  LendingFeeCalcType,
  LendingFeeCalcTypeBatchRequest,
} from '../types/LendingFeeCalcType';

export function getLendingFeeCalcTypes(): Promise<LendingFeeCalcType[]> {
  return apiGet<LendingFeeCalcType[]>('/api/lending-fee-calc-types');
}

export function saveLendingFeeCalcTypesBatch(
  added: LendingFeeCalcType[],
  modified: LendingFeeCalcType[],
  deletedIds: number[],
): Promise<LendingFeeCalcType[]> {
  return apiPatch<LendingFeeCalcTypeBatchRequest, LendingFeeCalcType[]>(
    '/api/lending-fee-calc-types/batch',
    {
      added,
      modified,
      deleted: deletedIds,
    },
  );
}
